import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {Col, Row, Badge, Modal, Dropdown, Spinner, ButtonGroup} from "react-bootstrap";
import OurDropdown from "../../../primer/Dropdown";
import Button from "react-bootstrap/Button";
import {toast} from "react-toastify";
import moment from "moment";
import {
    setClientContractsRequestData,
    setClientContractsResponseData,
} from "../../../../_reducers/DataPanel/Clients/clientSlice";
import Input from "../../../common/Input";
import ReportsTemplate from "../../../common/ReportsTemplate";
import {isEmpty, validateEmail} from "../../../../_helpers/commonFunctions";
import {MdCancel} from "react-icons/md";
import {convertToBase64} from "../Cloud/Components/constants";
import {FaEye} from "react-icons/fa";
import {TbFileShredder} from "react-icons/tb";
import {setForceRefresh} from "../../../../_reducers/SearchTableSlice";
import BetterCheckBox from "../../../common/BetterCheckBox";
import DateBox from "../../../primer/DateBox";
import DateTimeBox from "../../../primer/DateTimeBox";
import {IoDocumentText} from "react-icons/io5";
import {openClientLocal} from "../../../../_helpers/tabOpeners";

const ClientsProviderContractsReport = () => {
    /*
        THIS REPORT IS VIEWED BY PRIMER CONSTRUCTORS TOO. BE CAREFUL WHEN SHOWING DATA, USE isPrimerConstructor BOOLEAN AS NEEDED
     */
    const apiLoginURL = process.env.REACT_APP_LOGIN_URL;
    const dispatch = useDispatch();
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const SEARCH_TABLE = useSelector((state) => state.SEARCH_TABLE);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const requestData = useSelector((state) => state.CLIENTS_DATA.clientContractsReportRequestData);
    const responseData = useSelector((state) => state.CLIENTS_DATA.clientContractsReportResponseData);
    const [pageChanged, setPageChanged] = useState(false);
    const [subscriptionNames, setSubscriptionNames] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showUploadContractCheckModal, setShowUploadContractCheckModal] = useState(false);
    const [showUploadContractModal, setShowUploadContractModal] = useState(false);
    const [showEmailResendCheckModal, setShowEmailResendCheckModal] = useState(false);
    const [showEmailResendAcceptModal, setShowEmailResendAcceptModal] = useState(false);
    const [showProviderAcceptModal, setShowProviderAcceptModal] = useState(false);
    const [showContractLogsModal, setShowContractLogsModal] = useState(false);
    const [selectedClientForModal, setSelectedClientForModal] = useState(null);
    const [editableEmail, setEditableEmail] = useState("");
    const [contractLoader, setContractLoader] = useState(null);
    const [contractCheckLoader, setContractCheckLoader] = useState(null);
    const [contractLegalCheckLoader, setContractLegalCheckLoader] = useState(null);
    const [firstLoad, setFirstLoad] = useState(true);

    const [continueWithoutEmailLoader, setContinueWithoutEmailLoader] = useState(false);
    const [sendEmailToClientLoader, setSendEmailToClientLoader] = useState(false);
    const [resendEmailToClientLoader, setResendEmailToClientLoader] = useState(false);

    const [selectedContractToUpload, setSelectedContractToUpload] = useState(""); // base64 encoded PDF contract
    const [loadingUploadFile, setLoadingUploadFile] = useState(false);
    const [showDeleteContractModal, setShowDeleteContractModal] = useState(false);

    const [showStatementModal, setShowStatementModal] = useState(false);
    const [loadingShowStatementData, setLoadingShowStatementData] = useState(false);
    const [showStatementData, setShowStatementData] = useState({});
    const [toRecallStatement, setToRecallStatement] = useState("");
    const [recallStatus, setRecallStatus] = useState("2");
    const [recallDate, setRecallDate] = useState(moment().add(1, "day").format("YYYY-MM-DD")); // Only if recall status is 2
    const recallStatusOptions = [
        { label: "Πλήρης Ανάκληση", value: "2" },
        { label: "Μερική Ανάκληση", value: "1" },
    ]
    const [loadingRecall, setLoadingRecall] = useState(false);

    const [sendStatementTableData, setSendStatementTableData] = useState([]);
    const [showSendStatementTableModal, setShowSendStatementTableModal] = useState(false);

    const [loadingCheckAcceptance, setLoadingCheckAcceptance] = useState(false);
    const [loadingDeletion, setLoadingDeletion] = useState(false);

    const [loadingSendStatementData, setLoadingSendStatementData] = useState(false);
    const [showSendStatementModal, setShowSendStatementModal] = useState(false);
    const [loadingSendStatement, setLoadingSendStatement] = useState(false);
    const [selectedISP, setSelectedISP] = useState("Vodafone");
    const [ispInfo, setISPInfo] = useState({
        entityVatNumber: "",
        liableUserCategory: "",
        providerType: "",
        isB2BTransactions: false,
        isB2CTransactions: false,
        isB2GTransactions: false,
        providerVatNumber: "",
        providerLicenceNumber: "",
        providerContractNumber: "",
        providerContractConclusionDate: "",
        providerContractActivationDate: "",
        issueStartDate: "",
        internetProvider: "Vodafone",
        internetProviderContractNumber: "",
        internetProviderContractDate: moment().format("YYYY-MM-DDTHH:mm:ss[Z]"),
    });
    const [ispInfoEmail, setISPInfoEmail] = useState({
        sendEmail: false,
        email: "",
    })

    const ispOptions = [
        { value: "Vodafone", label: "Vodafone" },
        { value: "Cosmote", label: "Cosmote" },
        { value: "Nova", label: "Nova" },
        { value: "Q-Telecom", label: "Q-Telecom" },
        { value: "custom", label: "Άλλο" },
    ]

    const sendStatementStatuses = [
        { value: "sent", label: "Εστάλη" },
        { value: "accepted", label: "Έχει γίνει αποδοχή" },
        { value: "not_sent", label: "Δεν εστάλη" },
        { value: "recalled", label: "Ανακλημένη" },
    ]

    const legalCheck = "legalCheck";
    const uploadCheck = "uploadCheck";
    const contractSaved = "contractSaved";
    const acceptProvider = "acceptProvider";
    const sendStatement = "sendStatement";

    const permissionsData = JSON.parse(localStorage.getItem("user"))?.permissions;
    const isPrimerConstructor = permissionsData?.some((el) => el.permissionName === "custom-primerConstructor");

    useEffect(() => {
        getSubscriptionNames();
    }, [])

    useEffect(() => {
        if (pageChanged === true) {
            setPageChanged(false);
            fetchReport(false);
        }
    }, [pageChanged]);

    useEffect(() => {
        if (requestData?.forceRefresh) {
            fetchReport(true);
        }
    }, [requestData?.forceRefresh]);

    useEffect(() => {
        if(!isEmpty(selectedClientForModal)) {
            setISPInfoEmail({sendEmail: true, email: validateEmail(String(selectedClientForModal?.email).trim()) ? String(selectedClientForModal.email).trim() : ""});
        }
    }, [selectedClientForModal]);

    useEffect(() => {
        let load = false;
        if (firstLoad) {
            setFirstLoad(false);
            if (SEARCH_TABLE.forceRefresh["Client Contracts"]) {
                dispatch(setForceRefresh({...SEARCH_TABLE.forceRefresh, "Client Contracts": false}));
                load = true;
            }
        } else {
            load = true;
        }
        if (load) fetchReport(false);
    }, [firstLoad]);

    const openContractCheckModal = (clientData) => {
        setContractCheckLoader(clientData._id);
        setSelectedClientForModal(clientData);
        setEditableEmail(clientData ? clientData.email : "");
        setShowUploadContractCheckModal(true);
    }

    const openContractUploadModal = (clientData) => {
        setSelectedClientForModal(clientData);
        setEditableEmail("");
        setShowUploadContractModal(true);
    }

    const closeContractCheckModal = () => {
        setContractCheckLoader(null);
        setShowUploadContractCheckModal(false);
        setSelectedClientForModal(null);
        setEditableEmail("");
    }

    const openResendEmailCheckModal = (clientData) => {
        setSelectedClientForModal(clientData);
        setEditableEmail(clientData ? clientData.email : "");
        setShowEmailResendCheckModal(true);
    }

    const closeResendEmailCheckModal = () => {
        setShowEmailResendCheckModal(false);
        setSelectedClientForModal(null);
        setEditableEmail("");
    }

    const openResendEmailAcceptModal = (clientData) => {
        setSelectedClientForModal(clientData);
        setEditableEmail(clientData ? clientData.email : "");
        setShowEmailResendAcceptModal(true);
    }

    const closeResendEmailAcceptModal = () => {
        setShowEmailResendAcceptModal(false);
        setEditableEmail("");
        setSelectedClientForModal(null);
    }

    const openProviderAcceptModal = (clientData) => {
        setSelectedClientForModal(clientData);
        setEditableEmail(clientData ? clientData.email : "");
        setShowProviderAcceptModal(true);
    }

    const closeProviderAcceptModal = () => {
        setShowProviderAcceptModal(false);
        setSelectedClientForModal(null);
        setEditableEmail("");
    }

    const openContractLogsModal = (clientData) => {
        setShowContractLogsModal(true);
        setSelectedClientForModal(clientData);
    }

    const closeContractLogsModal = () => {
        setShowContractLogsModal(false);
        setSelectedClientForModal(null);
    }

    const openContractSendStatementModal = (clientData) => {
        setShowSendStatementModal(true);
        setLoadingSendStatementData(true);
        setSelectedClientForModal(clientData);
        axios.post(`${process.env.REACT_APP_API_URL2}/client/send-statement-fetch-data`, {
            _id: clientData._id,
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                const resData = res.data.data;
                setLoadingSendStatementData(false);
                setSelectedISP(ispOptions.some((el) => el.value === resData.internetProvider) ? resData.internetProvider : "custom");
                setISPInfo({
                    ...ispInfo,
                    ...resData,
                })
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleShowSendStatementData = (clientData, statementId) => {
        setSelectedClientForModal(clientData);
        setShowStatementModal(true);
        setLoadingShowStatementData(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/client/send-statement-sent-data`, {
            _id: clientData._id,
            company: company.id,
            statementId: statementId || undefined,
        }).then((res) => {
            if (res.data.status === "200") {
                const resData = res.data.data;
                setShowStatementData(resData);
                setLoadingShowStatementData(false);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleEmailChange = (e) => {
        setEditableEmail(e.target.value);
    }

    const handleAction = (emailToSend, client, resend) => {
        if (!isEmpty(client)) {
            const trimmedEmail = emailToSend ? emailToSend.trim() : '';
            let successMessage = "Η διαδικασία ολοκληρώθηκε επιτυχώς.";
            let errorMessage = "Το email δεν είναι έγκυρο. Αποτυχία αποστολής."
            let payload = {
                _id: client?._id,
            };
            if (trimmedEmail !== "") {
                setSendEmailToClientLoader(true);
                setResendEmailToClientLoader(true);
                const validEmail = validateEmail(trimmedEmail);
                if (resend) payload.resend = true;
                if (validEmail) {
                    payload.clientEmail = trimmedEmail;
                    successMessage = "Το email στάλθηκε επιτυχώς!";
                } else {
                    toast.error(errorMessage);
                    setSendEmailToClientLoader(false);
                    setResendEmailToClientLoader(false);
                    return;
                }
            }
            axios.post(process.env.REACT_APP_API_URL2 + "/client/upload-contract-check", payload, {
                headers: {"Content-Type": "application/json"}
            })
                .then((res) => {
                    if (res.data.status === "200") {
                        toast.success(successMessage);
                        closeContractCheckModal();
                        closeResendEmailCheckModal();
                        fetchReport(false);
                    } else {
                        toast.error(res.data.message);
                    }
                    closeContractCheckModal();
                    closeResendEmailCheckModal();
                    setContinueWithoutEmailLoader(false);
                    setSendEmailToClientLoader(false);
                    setResendEmailToClientLoader(false);
                    fetchReport(false);
                })
                .catch((error) => {
                    toast.error(error.message || "Αποτυχία API κλήσης.");
                    console.error(error);
                });
        } else {
            toast.error("Παρουσιάστηκε κάποιο πρόβλημα με τον επιλεγμένο πελάτη. Η αποστολή ειδοποίησης συμβολαίου απέτυχε.");
        }
    }

    const handleUploadContract = () => {
        setLoadingUploadFile(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/client/upload-provider-contract`, {
            _id: selectedClientForModal._id,
            company: company.id,
            selectedFile: selectedContractToUpload,
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής ανέβασμα συμβολαίου");
                setSelectedClientForModal(false);
                setSelectedContractToUpload("");
                setShowUploadContractModal(false);
                fetchReport(false);
            } else {
                toast.error(res.data.message);
            }
            setLoadingUploadFile(false);
        }).catch((err) => {
            console.log(err);
            setLoadingUploadFile(false);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const openSendStatementTableModal = (clientData) => {
        setSelectedClientForModal(clientData);
        setShowSendStatementTableModal(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/client/fetch-client-send-statements`, {
            _id: clientData._id,
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                setSendStatementTableData(res.data.data);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση.");
        })
    }

    const handleOnChange = (e, type, name) => {
        if (type === "input") {
            dispatch(setClientContractsRequestData({...requestData, [name]: e.target.value}));
        } else if (type === "msdd") {
            dispatch(setClientContractsRequestData({...requestData, [name]: e}));
        } else if (type === "dropdown") {
            dispatch(setClientContractsRequestData({...requestData, [name]: e.value}));
        }
    }

    const issueContract = (client) => {
        if (!isEmpty(client)) {
            setContractLoader(client._id);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/issue-provider-contract",
                {
                    _id: client?._id,
                },
                {
                    headers: {"Content-Type": "application/json"}
                }).then((res) => {
                if (res.data.status === "200") {
                    toast.success(res.data.message);
                    const binaryString = atob(res.data.data);
                    const byteArray = new Uint8Array(binaryString.split('').map((char) => char.charCodeAt(0)));
                    const blob = new Blob([byteArray], {type: "application/pdf"});
                    let blobUrl = URL.createObjectURL(blob);
                    blobUrl += "#navpanes=0&view=Fit";
                    window.open(blobUrl, "_blank");
                    fetchReport(false);
                } else {
                    toast.error(res.data.message);
                }
                setContractLoader(null);
            }).catch((error) => {
                toast.error(error);
                console.log(error);
                setContractLoader(null);
            })
        } else {
            toast.error("Παρουσιάστηκε κάποιο πρόβλημα με τον επιλεγμένο πελάτη. Η έκδοση συμβολαίου απέτυχε.");
        }
    }

    const handleLegalCheck = (client) => {
        if (!isEmpty(client)) {
            setContractLegalCheckLoader(client._id);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/contract-legal-check", {_id: client?._id}, {
                headers: {"Content-Type": "application/json"}
            }).then((res) => {
                if (res.data.status === "200") {
                    toast.success(res.data.message);
                    fetchReport(false);
                } else {
                    toast.error(res.data.message);
                }
                setContractLegalCheckLoader(null);
            }).catch((error) => {
                toast.error(error);
                console.log(error);
                setContractLegalCheckLoader(null);
            })
        } else {
            toast.error("Παρουσιάστηκε κάποιο πρόβλημα με τον επιλεγμένο πελάτη. Ο νομικός έλεγχος απέτυχε.");
        }
    }

    const handleProviderAcceptanceAction = (emailToSend, client, resend, autoOpenSendStatementModal = false) => {
        if (!isEmpty(client)) {
            const trimmedEmail = emailToSend ? emailToSend.trim() : '';
            let successMessage = "Η διαδικασία ολοκληρώθηκε επιτυχώς.";
            let errorMessage = "Το email δεν είναι έγκυρο. Αποτυχία αποστολής."
            let payload = {
                _id: client?._id,
            };
            if (resend) payload.resend = true;
            if (trimmedEmail !== "") {
                setSendEmailToClientLoader(true);
                setResendEmailToClientLoader(true);
                const validEmail = validateEmail(trimmedEmail);
                if (validEmail) {
                    payload.clientEmail = trimmedEmail;
                    successMessage = "Το email στάλθηκε επιτυχώς!";
                } else {
                    toast.error(errorMessage);
                    setSendEmailToClientLoader(false);
                    setResendEmailToClientLoader(false);
                    return;
                }
            }
            axios.post(process.env.REACT_APP_API_URL2 + "/client/contract-provider-accept", payload, {
                headers: {"Content-Type": "application/json"}
            }).then((res) => {
                if (res.data.status === "200") {
                    toast.success(successMessage);
                    if (autoOpenSendStatementModal) {
                        fetchReport(false);
                        setShowProviderAcceptModal(false);
                        setEditableEmail("");
                        openContractSendStatementModal(selectedClientForModal);
                        return;
                    }
                    closeProviderAcceptModal();
                    closeResendEmailAcceptModal();
                } else {
                    toast.error(res.data.message);
                }
                closeProviderAcceptModal();
                closeResendEmailAcceptModal();
                fetchReport(false);
                setContinueWithoutEmailLoader(false);
                setSendEmailToClientLoader(false);
                setResendEmailToClientLoader(false);
            }).catch((error) => {
                toast.error(error.message || "Αποτυχία API κλήσης.");
                console.error(error);
            });
        } else {
            toast.error("Παρουσιάστηκε κάποιο πρόβλημα με τον επιλεγμένο πελάτη. Η αποστολή ειδοποίησης απέτυχε.");
        }
    }

    const clientCardClicked = (clientObj, showSubscriptions) => {
        dispatch(openClientLocal(clientObj, TABS_DATA, showSubscriptions === true ? 7 : null));
    }

    const firstPage = () => {
        dispatch(setClientContractsRequestData({...requestData, page: 1}));
        setPageChanged(true);
    }
    const previousPage = () => {
        dispatch(setClientContractsRequestData({...requestData, page: requestData.page - 1}));
        setPageChanged(true);
    }
    const nextPage = () => {
        dispatch(setClientContractsRequestData({...requestData, page: requestData.page + 1}));
        setPageChanged(true);
    }
    const lastPage = () => {
        dispatch(setClientContractsRequestData({...requestData, page: (responseData.totalPages || 0)}));
        setPageChanged(true);
    }

    const getBackgroundColor = (row) => {
        const status = row.contractStatus.status;
        if (status === "ready") {
            return "#b1fcb1";
        } else if (["needs-legal-check", "needs-contract-upload", "needs-provider-acceptance", "needs-send-statement"].includes(status)) {
            return "#fff5bd";
        } else if (status === "needs-contract-saving") {
            return "#b8cfff";
        } else if (status === "inactive") {
            return "#ffcfcf";
        }
        return "";
    }

    const fetchReport = (showMsg) => {
        setLoading(true);
        let cloneReq = {...requestData};
        if (showMsg) cloneReq.page = 1;
        dispatch(setClientContractsRequestData({...cloneReq, forceRefresh: false}));

        axios.get(process.env.REACT_APP_API_URL2 + `/client/client-provider-contracts-report`, {
            headers: {"Content-Type": "application/json"},
            params: {
                ...cloneReq,
                company: company.id,
                user: JSON.parse(localStorage.getItem("user"))._id
            }
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                const response = res.data.data;
                if (res.data.data.totals) {
                    response.totals = res.data.data.totals;
                }
                dispatch(setClientContractsResponseData(response));
                if (showMsg) toast.success("Τα δεδομένα ανανεώθηκαν.", {autoClose: 1000});
            }
        }).catch((err) => {
            setLoading(false);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            console.log(err);
        })
    }

    const getSubscriptionNames = () => {
        axios.get(process.env.REACT_APP_API_URL2 + `/settings/get-subscription-names`, {
            headers: {"Content-Type": "application/json"},
            params: {
                company: company.id,
                user: JSON.parse(localStorage.getItem("user"))._id,
            }
        }).then((res) => {
            if (res.data.status === "401") {
                localStorage.clear();
                window.location.replace(`${apiLoginURL}?redirect=ERP&error=You are not Authorized!`);
            } else if (res.data.status === "200") {
                let finalData = [];
                if (res.data.data && res.data.data?.length > 0) {
                    res.data.data.forEach((sub) => {
                        finalData.push({
                            label: sub,
                            value: sub,
                        })
                    })
                }
                setSubscriptionNames(finalData);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const contractStatusOptions = [
        {label: "Ανενεργό", value: "inactive"},
        {label: "Εκκρεμεί Νομικός Έλεγχος", value: "needs-legal-check"},
        {label: "Εκκρεμεί Αποστολή Συμβολαίου", value: "needs-contract-upload"},
        {label: "Εκκρεμεί Αποθήκευση Συμβολαίου", value: "needs-contract-saving"},
        {label: "Εκκρεμεί Αποδοχή Παρόχου", value: "needs-provider-acceptance"},
        {label: "Εκκρεμεί Δήλωση Έκδοσης Στοιχείων", value: "needs-send-statement"},
        {label: "Έτοιμο", value: "ready"}
    ]

    const getContractStatus = (status) => {
        if (status === "inactive") {
            return {status: "Ανενεργό"}
        } else if (status === "needs-legal-check") {
            return {status: "Εκκρεμεί Νομικός Έλεγχος"}
        } else if (status === "needs-contract-upload") {
            return {status: "Εκκρεμεί Αποστολή Συμβολαίου"}
        } else if (status === "needs-provider-acceptance") {
            return {status: "Εκκρεμεί Αποδοχή Παρόχου"}
        } else if (status === "needs-contract-saving") {
            return {status: "Εκκρεμεί Αποθήκευση Συμβολαίου"}
        } else if (status === "needs-send-statement") {
            return {status: "Εκκρεμεί Δήλωση Έκδοσης Στοιχείων"}
        } else if (status === "ready") {
            return {status: "Έτοιμο"}
        }
    }

    const handleFetchContract = (clientData) => {
        axios.post(`${process.env.REACT_APP_API_URL2}/client/fetch-provider-contract`, {
            _id: clientData._id,
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                const base64Encoded = res.data.data;
                const binaryString = atob(base64Encoded);
                const len = binaryString.length;
                const bytes = new Uint8Array(len);
                for (let i = 0; i < len; i++) bytes[i] = binaryString.charCodeAt(i);
                const blob = new Blob([bytes], { type: 'application/pdf' });
                let blobUrl = URL.createObjectURL(blob);
                blobUrl += "#navpanes=0&view=Fit";
                window.open(blobUrl, "_blank");
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleAcceptDeletion = () => {
        setLoadingDeletion(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/client/delete-provider-contract`, {
            _id: selectedClientForModal._id,
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής διαγραφή.");
                fetchReport(false);
                setShowDeleteContractModal(false);
            } else {
                toast.error(res.data.message);
            }
            setLoadingDeletion(false);
        }).catch((err) => {
            setLoadingDeletion(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const getClientContactPoints = (client) => {
        if (!client) {
            return {uniqueEmails: [], uniquePhones: []};
        }
        const emailSet = new Set();
        const phoneSet = new Set();
        if (client.email) {
            emailSet.add(client.email.toLowerCase().trim());
        }
        if (client.phone) {
            phoneSet.add(client.phone.trim());
        }
        if (client.contactPoints && Array.isArray(client.contactPoints)) {
            client.contactPoints.forEach(contact => {
                if (contact.email) {
                    emailSet.add(contact.email.toLowerCase().trim());
                }
                if (contact.mobile) {
                    phoneSet.add(contact.mobile.trim());
                }
                if (contact.otherPhone) {
                    phoneSet.add(contact.otherPhone.trim());
                }
                if (contact.landline) {
                    phoneSet.add(contact.landline.trim());
                }
            });
        }
        const uniqueEmails = Array.from(emailSet);
        const uniquePhones = Array.from(phoneSet);
        return {uniqueEmails, uniquePhones};
    }

    const handleSendStatement = () => {
        if (Object.values(ispInfo).some((el) => isEmpty(el))) {
            return toast.error("Παρακαλώ συμπληρώστε όλα τα πεδία.");
        }
        setLoadingSendStatement(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/client/send-statement-contract`, {
            _id: selectedClientForModal._id,
            company: company.id,
            ispInfo,
            ispInfoEmail,
        }).then((res) => {
            setLoadingSendStatement(false);
            if (res.data.status === "200") {
                setShowSendStatementModal(false);
                toast.success("Επιτυχής αποστολή.");
                fetchReport(false);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoadingSendStatement(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const formatMyDataProviderType = (val) => {
        if (val === "1") {
            return "Πάροχος";
        } else if (val === "2") {
            return "Ιδιοπάροχος";
        }
        return "-";
    }

    const handleRecallStatement = () => {
        if (isEmpty(recallDate) && recallStatus === "1") return toast.error("Παρακαλώ συμπληρώστε ημερομηνία ανάκλησης.");
        setLoadingRecall(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/client/recall-send-statement`, {
            _id: selectedClientForModal._id,
            company: company.id,
            statementId: toRecallStatement,
            recallStatus: recallStatus,
            recallDate: recallDate,
        }).then((res) => {
            if (res.data.status === "200") {
                setToRecallStatement("");
                setShowStatementModal(false);
                setShowStatementData({});
                setRecallStatus("2");
                setRecallDate(moment().add(1, "day").format("YYYY-MM-DD"))
                toast.success("Επιτυχής ανάκληση.");
                fetchReport(false);
            } else {
                toast.error(res.data.message);
            }
            setLoadingRecall(false);
        }).catch((err) => {
            setLoadingRecall(false);
            console.log(err);
            toast.error("Σφάλμα κατά την διαγραφή.");
        })
    }

    const formatStatementStatus = (status) => {
        if (status === "sent") {
            return "Εστάλη";
        } else if (status === "accepted") {
            return "Ολοκληρωμένη";
        } else if (status === "recalled") {
            return "Ανακλημένη";
        }
        return status;
    }

    const handleCheckAcceptance = (statementObj) => {
        setLoadingCheckAcceptance(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/client/send-statement-check-acceptance`, {
            _id: statementObj._id,
        }).then((res) => {
            if (res.data.status === "200") {
                setShowStatementData(res.data.data);
                if (res.data.status === "accepted") {
                    toast.success("Επιτυχής έλεγχος, η δήλωση έχει γίνει δεκτή.");
                } else {
                    toast.info("Επιτυχής έλεγχος, δεν υπήρξε κάποια αλλαγή.");
                }
            } else {
                toast.error(res.data.message);
            }
            setLoadingCheckAcceptance(false);
        }).catch((err) => {
            setLoadingCheckAcceptance(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    return (
        <React.Fragment>
            <ReportsTemplate templateType={"reports-clients-provider-contracts"} requestData={requestData}
                             fetchReport={() => fetchReport()}
                             setRequestData={(data) => dispatch(setClientContractsRequestData(data))}
                             header={"Συμβόλαια Παρόχου"}/>
            <Row className={"mb-2"} onKeyDown={(e) => {
                if (e.key === "Enter") fetchReport(true)
            }
            }>
                <Col md={2}>
                    <OurDropdown
                        name={"statuses"}
                        label={"Κατάσταση Συμβολαίου"}
                        key={Math.random()}
                        multiSelect={true}
                        options={contractStatusOptions}
                        defaultValue={requestData.statuses}
                        onChange={(e) => handleOnChange(e, "msdd", "statuses")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name="clientName"
                        label="Όνομα/ΑΦΜ Πελάτη/Νόμιμου Επροσώπου"
                        autoComplete="off"
                        value={requestData.clientName}
                        onChange={(e) => handleOnChange(e, "input", "clientName")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name="clientEmail"
                        label="Email Πελάτη"
                        autoComplete="off"
                        value={requestData.clientEmail}
                        onChange={(e) => handleOnChange(e, "input", "clientEmail")}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        name="subscriptionId"
                        label="Αριθμός Συνδρομής"
                        autoComplete="off"
                        value={requestData.subscriptionId}
                        onChange={(e) => handleOnChange(e, "input", "subscriptionId")}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        name="clientPhone"
                        label="Τηλέφωνο Πελάτη"
                        autoComplete="off"
                        value={requestData.clientPhone}
                        onChange={(e) => handleOnChange(e, "input", "clientPhone")}
                    />
                </Col>
                {!isPrimerConstructor && (
                    <React.Fragment>
                        <Col md={2}>
                            <OurDropdown
                                name="subscriptionNames"
                                label="Συνδρομές"
                                key={Math.random()}
                                multiSelect={true}
                                options={subscriptionNames}
                                defaultValue={requestData.subscriptionNames}
                                onChange={(e) => handleOnChange(e, "msdd", "subscriptionNames")}
                            />
                        </Col>
                    </React.Fragment>
                )}
                <Col md={2}>
                    <OurDropdown
                        name="sendStatementStatus"
                        label="Κατάσταση Δήλωσης Έκδοσης Στοιχείων"
                        key={Math.random()}
                        multiSelect={true}
                        options={sendStatementStatuses}
                        defaultValue={requestData.sendStatementStatus}
                        onChange={(e) => handleOnChange(e, "msdd", "sendStatementStatus")}
                    />
                </Col>
            </Row>
            <Row className="mb-3 mt-2 justify-content-end">
                <Col md={3} style={{display: "flex", justifyContent: "right"}}>
                    <Button onClick={() => fetchReport(true)} disabled={loading}>
                        {"Εφαρμογή φίλτρων και αναζήτηση "}
                        {loading && (<span className="spinner-border spinner-border-sm ml-1" role="status"
                                           aria-hidden="true"></span>)}
                    </Button>
                </Col>
            </Row>
            {responseData.totalPages > 0 && (
                <React.Fragment>
                    <hr/>
                    <Row className="mb-3 justify-content-end">
                        <Col md={9} style={{display: "flex", justifyContent: "right"}}>
                            {(responseData.totalItems !== 0 && responseData.data?.length > 0) && (<div className={"mr-3 mt-2"}><i>Σύνολο Αποτελεσμάτων: {responseData.totalItems}</i></div>)}
                            <Button size="sm" className="mr-1" onClick={() => firstPage()}
                                    disabled={requestData.page === 1 || loading}>{"<< Πρώτη"}</Button>
                            <Button size="sm" className="mr-1" onClick={() => previousPage()}
                                    disabled={requestData.page === 1 || loading}>{"< Προηγούμενη"}</Button>
                            <Badge style={{fontSize: "12px", lineHeight: "20px"}} className="mr-1"
                                   bg="primary">Σελίδα {requestData.page} / {responseData.totalPages}</Badge>
                            <Button size="sm" className="mr-1" onClick={() => nextPage()}
                                    disabled={requestData.page === responseData.totalPages || loading}>{"Επόμενη >"}</Button>
                            <Button size="sm" className="mr-1" onClick={() => lastPage()}
                                    disabled={requestData.page === responseData.totalPages || loading}>{"Τελευταία >>"}</Button>
                        </Col>
                    </Row>
                    <Row className={"mt-2 mb-3"}>
                        <Col md={12}>
                            <table className={"simpleClassicTable simpleClassicTableGrayHover"} style={{fontSize: "12px"}}>
                                <colgroup>
                                    <col span={1} style={{width: "2%"}}></col>
                                    <col span={1} style={{width: "18%"}}></col>
                                    <col span={1} style={{width: "8%"}}></col>
                                    <col span={1} style={{width: "7%"}}></col>
                                    <col span={1} style={{width: "12%"}}></col>
                                    <col span={1} style={{width: "9%"}}></col>
                                    <col span={1} style={{width: "7%"}}></col>
                                    <col span={1} style={{width: "7%"}}></col>
                                    <col span={1} style={{width: "7%"}}></col>
                                    {!isPrimerConstructor ? (
                                        <React.Fragment>
                                            <col span={1} style={{width: "7%"}}></col>
                                            <col span={1} style={{width: "7%"}}></col>
                                            <col span={1} style={{width: "7%"}}></col>
                                            <col span={1} style={{width: "9%"}}></col>
                                            <col span={1} style={{width: "9%"}}></col>
                                            <col span={1} style={{width: "7%"}}></col>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            <col span={1} style={{width: "7%"}}></col>
                                        </React.Fragment>
                                    )}
                                    <col span={1} style={{width: "9%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>Aρ.</th>
                                    <th>Όνομα Επιχείρησης</th>
                                    <th>ΑΦΜ</th>
                                    <th>Τηλέφωνο</th>
                                    <th>Email</th>
                                    <th>Νόμιμος Εκπρόσωπος</th>
                                    <th>ΑΦΜ Νόμιμου Εκπροσώπου</th>
                                    <th>Ημερομηνία Ενεργοποίησης</th>
                                    <th>Κατάσταση Συμβολαίου</th>
                                    {!isPrimerConstructor ? (
                                        <React.Fragment>
                                            <th>Έκδοση Συμβολαίου</th>
                                            <th>Νομικός Έλεγχος</th>
                                            <th>Έλεγχος Αποστολής Συμβολαίου</th>
                                            <th>Αποθήκευση Συμβολαίου</th>
                                            <th>Αποδοχή Παρόχου</th>
                                            <th>Δήλωση Έκδοσης Στοιχείων</th>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            <th>Έγγραφα / Δηλώσεις</th>
                                        </React.Fragment>
                                    )}
                                    <th>Ενέργειες</th>
                                </tr>
                                </thead>
                                <tbody>
                                {responseData.data.map((client, index) => {
                                    const {uniqueEmails, uniquePhones} = getClientContactPoints(client);
                                    return (
                                        <tr key={`con-${index}`}>
                                            <td>{client.no}</td>
                                            <td>
                                                {client.name}
                                                {client?.subscriptions?.some((el) => !isEmpty(el.linkedConstructorName)) && (
                                                    <Badge bg={"primary"} style={{
                                                        width: "100%",
                                                        whiteSpace: "normal"
                                                    }}>
                                                        Κατασκευαστής: {client?.subscriptions?.find((el) => !isEmpty(el.linkedConstructorName))?.linkedConstructorName}
                                                    </Badge>
                                                )}
                                            </td>
                                            <td>
                                                {client.vatNumber}
                                                {client?.subscriptions?.some((el) => !isEmpty(el.linkedConstructorVat)) && (
                                                    <Badge bg={"primary"} style={{
                                                        width: "100%",
                                                        whiteSpace: "normal"
                                                    }}>
                                                        Κατασκευαστής: {client?.subscriptions?.find((el) => !isEmpty(el.linkedConstructorVat))?.linkedConstructorVat}
                                                    </Badge>
                                                )}
                                            </td>
                                            <td>
                                                {uniquePhones.length > 0 ? (
                                                    uniquePhones.join(', ')
                                                ) : ""}
                                            </td>
                                            <td>
                                                {uniqueEmails.length > 0 ? (
                                                    uniqueEmails.join(', ')
                                                ) : ""}
                                            </td>
                                            <td>{client.representativeName}{" "}{client.representativeSurname}</td>
                                            <td>{client.representativeVatNumber}</td>
                                            <td>{
                                                (() => {
                                                    if (!client.subscriptions || client.subscriptions.length === 0) {
                                                        return "";
                                                    }
                                                    const validSubscriptions = client.subscriptions.filter(s =>
                                                        s.activatedDate && moment(s.activatedDate).isValid()
                                                    );
                                                    if (validSubscriptions.length === 0) {
                                                        return "";
                                                    }
                                                    const oldestSubscription = validSubscriptions.reduce((oldest, current) => {
                                                        const oldestMoment = moment(oldest.activatedDate);
                                                        const currentMoment = moment(current.activatedDate);
                                                        return currentMoment.isBefore(oldestMoment) ? current : oldest;
                                                    });
                                                    return moment(oldestSubscription.activatedDate).format("DD/MM/YYYY");
                                                })()
                                            }</td>
                                            <td style={{padding: "3px", backgroundColor: getBackgroundColor(client)}}>{getContractStatus(client.contractStatus.status).status}</td>
                                            {!isPrimerConstructor ? (
                                                <React.Fragment>
                                                    <td style={{padding: "3px"}}>
                                                        <Button size="sm" style={{minWidth: "70px", paddingLeft: "5px", paddingRight: "5px", fontSize: "12px"}}
                                                                disabled={
                                                                    contractLoader === client._id
                                                                    || client.contractStatus.status === "inactive"}
                                                                variant="primary" onClick={() => issueContract(client)}>
                                                            {contractLoader === client._id ? (
                                                                <span
                                                                    className="spinner-border spinner-border-xs ml-auto mr-auto"
                                                                    role="status" aria-hidden="true"></span>) : "Έκδοση"}
                                                        </Button>
                                                    </td>
                                                    <td style={{padding: "3px"}}>
                                                        <Button size="sm" style={{minWidth: "70px", paddingLeft: "5px", paddingRight: "5px", fontSize: "12px"}}
                                                                disabled={
                                                                    contractLegalCheckLoader === client._id ||
                                                                    ((client?.contractStatuses?.contractStatusString !== "needs-legal-check" && !isEmpty(client?.contractStatuses?.contractStatusString)) || client?.contractStatuses?.[legalCheck] === true)
                                                                }
                                                                variant="primary" onClick={() => handleLegalCheck(client)}>
                                                            {contractLegalCheckLoader === client._id ? (
                                                                <span
                                                                    className="spinner-border spinner-border-xs ml-auto mr-auto"
                                                                    role="status" aria-hidden="true"></span>) : "Έλεγχος"}
                                                        </Button>
                                                    </td>
                                                    <td style={{padding: "3px"}}>
                                                        <Button size="sm" style={{minWidth: "70px", paddingLeft: "5px", paddingRight: "5px", fontSize: "12px"}}
                                                                disabled={
                                                                    contractCheckLoader === client._id ||
                                                                    (client?.contractStatuses?.[legalCheck] !== true || client?.contractStatuses?.[uploadCheck] === true)
                                                                }
                                                                variant="primary"
                                                                onClick={() => openContractCheckModal(client)}>
                                                            {contractCheckLoader === client._id ? (
                                                                <span
                                                                    className="spinner-border spinner-border-xs ml-auto mr-auto"
                                                                    role="status" aria-hidden="true"></span>) : "'Ελεγχος"}
                                                        </Button>
                                                    </td>
                                                    <td style={{padding: "3px"}}>
                                                        {client?.contractStatuses?.contractSaved === true ? (
                                                            <ButtonGroup style={{minWidth: "70px", paddingLeft: "5px", paddingRight: "5px", fontSize: "12px"}}>
                                                                <Button size="sm" variant="primary" title={"Προβολή συμβολαίου"} style={{padding: "5px"}} onClick={() => handleFetchContract(client)}>
                                                                    <FaEye size={20} />
                                                                </Button>
                                                                <Button size="sm" variant="outline-danger"
                                                                        title={"Διαγραφή Συμβολαίου"} style={{padding: "5px"}}
                                                                        onClick={() => {
                                                                            setSelectedClientForModal(client);
                                                                            setShowDeleteContractModal(true);
                                                                        }}>
                                                                    <TbFileShredder size={20}/>
                                                                </Button>
                                                            </ButtonGroup>
                                                        ) : (
                                                            <Button size="sm" style={{minWidth: "70px", paddingLeft: "5px", paddingRight: "5px", fontSize: "12px"}}
                                                                    disabled={
                                                                        (client?.contractStatuses?.[uploadCheck] !== true || client?.contractStatuses?.[contractSaved] === true)
                                                                    }
                                                                    variant="primary"
                                                                    onClick={() => openContractUploadModal(client)}>
                                                                Αποθήκευση
                                                            </Button>
                                                        )}
                                                    </td>
                                                    <td style={{padding: "3px"}}>
                                                        <Button size="sm" style={{minWidth: "70px", paddingLeft: "5px", paddingRight: "5px", fontSize: "12px"}}
                                                                disabled={
                                                                    (client?.contractStatuses?.[contractSaved] !== true || client?.contractStatuses?.[acceptProvider] === true)
                                                                }
                                                                variant="primary"
                                                                onClick={() => openProviderAcceptModal(client)}>
                                                            Αποδοχή
                                                        </Button>
                                                    </td>
                                                    <td style={{padding: "3px"}}>
                                                        {(client?.contractStatuses?.[sendStatement] === true) ? (
                                                            <Button size="sm" variant="primary" title={"Προβολή Έκδοσης Στοιχείων"} style={{padding: "5px"}} onClick={() => handleShowSendStatementData(client)}>
                                                                <FaEye size={20} />
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                size={"sm"}
                                                                style={{minWidth: "70px", paddingLeft: "5px", paddingRight: "5px", fontSize: "12px"}}
                                                                disabled={client?.contractStatuses?.[acceptProvider] !== true}
                                                                onClick={() => openContractSendStatementModal(client)}
                                                            >
                                                                Αποστολή
                                                            </Button>
                                                        )}
                                                    </td>
                                                </React.Fragment>
                                            ) : (
                                                <React.Fragment>
                                                    <td>
                                                        <Button size="sm" variant="primary" title={"Προβολή συμβολαίου"} disabled={client?.contractStatuses?.contractSaved !== true}
                                                                style={{padding: "5px"}} onClick={() => handleFetchContract(client)}>
                                                            <IoDocumentText size={20} />
                                                        </Button>
                                                        <Button size="sm" variant="primary" title={"Προβολή Έκδοσης Στοιχείων Παρόχου"} disabled={client?.contractStatuses?.sendStatement !== true}
                                                                style={{padding: "5px", marginLeft: "5px"}} onClick={() => handleShowSendStatementData(client)}>
                                                            <FaEye size={20} />
                                                        </Button>
                                                    </td>
                                                </React.Fragment>
                                            )}
                                            <td style={{padding: "3px"}}>
                                                <Dropdown direction={"start"} drop={"start"}>
                                                    <Dropdown.Toggle variant={"primary"} size={"sm"}
                                                                     style={{flex: "1", width: "100%"}}>
                                                        Ενέργειες
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu style={{
                                                        marginRight: "3px",
                                                        borderRadius: "8px",
                                                        border: "2px solid #d9d7d7",
                                                        boxShadow: "rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px",
                                                        padding: "0px",
                                                        overflow: "hidden",
                                                        textAlign: "center",
                                                    }}>
                                                        <Dropdown.Item
                                                            onClick={() => clientCardClicked(client)}>{"Προβολή Πελάτη"}</Dropdown.Item>
                                                        <Dropdown.Item
                                                            onClick={() => clientCardClicked(client, true)}>{"Προβολή Συνδρομών Πελάτη"}</Dropdown.Item>
                                                        <Dropdown.Item
                                                            disabled={!client?.contractLogs || client?.contractLogs.length === 0}
                                                            onClick={() => openContractLogsModal(client)}>{"Προβολή καταγραφών"}</Dropdown.Item>
                                                        {!isPrimerConstructor && (
                                                            <React.Fragment>
                                                                <Dropdown.Item disabled={!client?.contractStatuses?.uploadCheck}
                                                                               onClick={() => openResendEmailCheckModal(client)}>{"Επαναποστολή Email Οδηγιών"}</Dropdown.Item>
                                                                <Dropdown.Item
                                                                    disabled={!client?.contractStatuses?.acceptProvider}
                                                                    onClick={() => openResendEmailAcceptModal(client)}>{"Επαναποστολή Email Ολοκλήρωσης"}</Dropdown.Item>
                                                                <Dropdown.Item
                                                                    disabled={!client?.contractLogs || client?.contractLogs.length === 0}
                                                                    onClick={() => openSendStatementTableModal(client)}>{"Προβολή Εκδόσεων Στοιχείων μέσω Παρόχου"}</Dropdown.Item>
                                                            </React.Fragment>
                                                        )}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    )
                                })}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <Row className={"mt-2 mb-3"}>
                        <Col md={4} className="ms-auto">
                            {responseData.totals && (
                                <table className={"simpleClassicTable"} style={{fontSize: "14px", fontWeight: "600"}}>
                                    <thead>
                                    <tr>
                                        <th colSpan={2} style={{textAlign: "center", fontSize: "14px", padding: "5px"}}>
                                            Σύνολα Καταστάσεων Συμβολαίων
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <th>Ανενεργά</th>
                                        <td style={{fontSize: "14px", backgroundColor: "#ffcfcf"}}>
                                            {responseData.totals?.inactive || 0}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Εκκρεμεί Νομικός Έλεγχος</th>
                                        <td style={{fontSize: "14px", backgroundColor: "#fff5bd"}}>
                                            {responseData.totals?.['needs-legal-check'] || 0}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Εκκρεμεί Αποστολή Συμβολαίου</th>
                                        <td style={{fontSize: "14px", backgroundColor: "#fff5bd"}}>
                                            {responseData.totals?.['needs-contract-upload'] || 0}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Εκκρεμεί Ανέβασμα Συμβολαίου</th>
                                        <td style={{fontSize: "14px", backgroundColor: "#b8cfff"}}>
                                            {responseData.totals?.['needs-contract-saving'] || 0}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Εκκρεμεί Αποδοχή Παρόχου</th>
                                        <td style={{fontSize: "14px", backgroundColor: "#fff5bd"}}>
                                            {responseData.totals?.['needs-provider-acceptance'] || 0}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Έτοιμα</th>
                                        <td style={{fontSize: "14px", backgroundColor: "#b1fcb1"}}>
                                            {responseData.totals?.ready || 0}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Σύνολο</th>
                                        <td style={{fontSize: "14px"}}>
                                            {responseData.totals?.total || 0}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            )}
                        </Col>
                    </Row>

                    <Modal backdrop={"static"} show={showUploadContractCheckModal} onHide={closeContractCheckModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Αποστολή Email στον πελάτη</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col md={12}>
                                    <Input
                                        name="clientEmail"
                                        label="Αποστολή στο:"
                                        autoComplete="off"
                                        value={editableEmail}
                                        onChange={handleEmailChange}
                                    />
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Row>
                                <Col md={6}>
                                    <Button variant="outline-primary" disabled={continueWithoutEmailLoader}
                                            onClick={() => handleAction("", selectedClientForModal)}>
                                        Συνέχεια χωρίς αποστολή
                                        {continueWithoutEmailLoader && (
                                            <span className="spinner-border spinner-border-sm ml-1" role="status"
                                                  aria-hidden="true"></span>)}
                                    </Button>
                                </Col>
                                <Col md={6}>
                                    <Button variant="primary" disabled={sendEmailToClientLoader}
                                            onClick={() => handleAction(editableEmail, selectedClientForModal)}>
                                        Συνέχεια με αποστολή
                                        {sendEmailToClientLoader && (
                                            <span className="spinner-border spinner-border-sm ml-1" role="status"
                                                  aria-hidden="true"></span>)}
                                    </Button>
                                </Col>
                            </Row>
                        </Modal.Footer>
                    </Modal>

                    <Modal backdrop={"static"} show={showEmailResendCheckModal} onHide={closeResendEmailCheckModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Επαναποστολή Email Οδηγιών</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col md={12}>
                                    <Input
                                        name="clientEmail"
                                        label="Αποστολή στο:"
                                        autoComplete="off"
                                        value={editableEmail}
                                        onChange={handleEmailChange}
                                    />
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" disabled={resendEmailToClientLoader}
                                    onClick={() => handleAction(editableEmail, selectedClientForModal, true)}>
                                Αποστολή
                                {resendEmailToClientLoader && (
                                    <span className="spinner-border spinner-border-sm ml-1" role="status"
                                          aria-hidden="true"></span>)}
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal backdrop={"static"} show={showEmailResendAcceptModal} onHide={closeResendEmailAcceptModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Επαναποστολή Email Ολοκλήρωσης</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col md={12}>
                                    <Input
                                        name="clientEmail"
                                        label="Αποστολή στο:"
                                        autoComplete="off"
                                        value={editableEmail}
                                        onChange={handleEmailChange}
                                    />
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" disabled={resendEmailToClientLoader}
                                    onClick={() => handleProviderAcceptanceAction(editableEmail, selectedClientForModal, true)}>
                                Αποστολή
                                {resendEmailToClientLoader && (
                                    <span className="spinner-border spinner-border-sm ml-1" role="status"
                                          aria-hidden="true"></span>
                                )}
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={showProviderAcceptModal} onHide={() => closeProviderAcceptModal()}>
                        <Modal.Header closeButton>
                            <Modal.Title>Αποδοχή Παρόχου</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Είσαστε σίγουροι ότι θέλετε να πραγματοποιήσετε αποδοχή παρόχου;
                            {/*
                            <Row>
                                <Col md={12}>
                                    <Input
                                        name="clientEmail"
                                        label="Αποστολή στο:"
                                        autoComplete="off"
                                        value={editableEmail}
                                        onChange={handleEmailChange}
                                    />
                                </Col>
                            </Row>
                            */}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-primary" onClick={() => handleProviderAcceptanceAction("", selectedClientForModal, false, false)}>
                                Αποδοχή
                            </Button>
                            <Button variant="primary" onClick={() => handleProviderAcceptanceAction("", selectedClientForModal, false, true)}>
                                Αποδοχή & προς Δήλωση
                            </Button>
                            {/*
                            <Row>
                                <Col md={6}>
                                    <Button variant="outline-primary"
                                            disabled={continueWithoutEmailLoader}
                                            onClick={() => handleProviderAcceptanceAction("", selectedClientForModal)}>
                                        Συνέχεια χωρίς αποστολή
                                        {continueWithoutEmailLoader && (
                                            <span className="spinner-border spinner-border-sm ml-1" role="status"
                                                  aria-hidden="true"></span>)}
                                    </Button>
                                </Col>
                                <Col md={6}>
                                    <Button variant="primary"
                                            disabled={sendEmailToClientLoader}
                                            onClick={() => handleProviderAcceptanceAction(editableEmail, selectedClientForModal)}>
                                        Συνέχεια με αποστολή
                                        {sendEmailToClientLoader && (
                                            <span className="spinner-border spinner-border-sm ml-1" role="status"
                                                  aria-hidden="true"></span>)}
                                    </Button>
                                </Col>
                            </Row>
                            */}
                        </Modal.Footer>
                    </Modal>

                    <Modal backdrop={"static"} show={showUploadContractModal} onHide={() => {
                        if (!loadingUploadFile) setShowUploadContractModal(false)
                    }}>
                        <Modal.Header closeButton={!loadingUploadFile}>
                            <Modal.Title>Μεταφόρτωση συμβολαίου πελάτη</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col md={selectedContractToUpload ? 10 : 12}>
                                    <input
                                        type={"file"}
                                        id={"upload_primer_client_contract"}
                                        className={"form-control"}
                                        accept={"application/pdf"}
                                        style={{lineHeight: "1.7"}}
                                        onChange={async (e) => {
                                            const file = e.target.files[0];
                                            if (!file) {
                                                return toast.error("Παρακαλώ επιλέξτε ένα αρχείο");
                                            }
                                            const base64Encoded = await convertToBase64(file);
                                            setSelectedContractToUpload(base64Encoded);
                                        }}
                                        disabled={selectedContractToUpload !== ""}
                                    />
                                </Col>
                                {selectedContractToUpload && (
                                    <Col md={2}>
                                        <Button style={{marginTop: "3px"}} size={"sm"}
                                                onClick={() => setSelectedContractToUpload("")}
                                                title={"Αποεπιλογή αρχείου"}>
                                            <MdCancel/>
                                        </Button>
                                    </Col>
                                )}
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-primary" onClick={() => setShowUploadContractModal(false)}
                                    disabled={loadingUploadFile}>
                                Κλείσιμο
                            </Button>
                            <Button variant="primary" onClick={() => handleUploadContract()}
                                    disabled={loadingUploadFile}>
                                Μεταφόρτωση {loadingUploadFile &&
                                <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={showDeleteContractModal} onHide={() => setShowDeleteContractModal(false)} backdrop={"static"}>
                        <Modal.Header closeButton>
                            <Modal.Title>Διαγραφή Συμβολαίου</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {showDeleteContractModal && (
                                <React.Fragment>
                                    <strong>Προσοχή!</strong> Είσαστε σίγουροι ότι θέλετε να διαγράψετε το συμβόλαιο του
                                    πελάτη <strong>{selectedClientForModal.name}</strong> με
                                    ΑΦΜ <strong>{selectedClientForModal.vatNumber}</strong>;
                                    {selectedClientForModal?.contractStatuses?.sendStatement === true && (
                                        <span> Κατά την διαγραφή του συμβολαίου θα γίνει και <u style={{color: "red"}}>ανάκληση</u> της Δήλωσης Έκδοσης Στοιχείων Παρόχου!</span>
                                    )}
                                </React.Fragment>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-primary" onClick={() => setShowDeleteContractModal(false)}>
                                Κλείσιμο
                            </Button>
                            <Button variant="primary" onClick={() => handleAcceptDeletion()} disabled={loadingDeletion}>
                                {selectedClientForModal?.contractStatuses?.sendStatement === true ? (
                                    <span>Ανάκληση & Διαγραφή</span>
                                ) : (
                                    <span>Διαγραφή</span>
                                )}
                                {loadingDeletion && (
                                    <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />
                                )}
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal backdrop={"static"} show={showContractLogsModal} onHide={closeContractLogsModal}
                           dialogClassName={"modal65PercentWidth"}>
                        <Modal.Header closeButton>
                            <Modal.Title>Καταγραφές Συμβολαίου</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row className={"mt-2 mb-3"}>
                                <Col md={12}>
                                    <table className={"simpleClassicTable"} style={{fontSize: "14px"}}>
                                        <colgroup>
                                            <col span={1} style={{width: "4%"}}></col>
                                            <col span={1} style={{width: "30%"}}></col>
                                            <col span={1} style={{width: "20%"}}></col>
                                            <col span={1} style={{width: "30%"}}></col>
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th></th>
                                            <th>Ημερομηνία/Ώρα</th>
                                            <th>Χρήστης</th>
                                            <th>Λεπτομέρειες</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {selectedClientForModal?.contractLogs?.length > 0 &&
                                            [...selectedClientForModal.contractLogs]
                                                .sort((a, b) => new Date(b.date) - new Date(a.date))
                                                .map((log, index) => (
                                                    <tr key={`log-${index}`}>
                                                        <td>{index + 1}</td>
                                                        <td>{moment(log.date).format("DD/MM/YYYY HH:mm")}</td>
                                                        <td>{log.user}</td>
                                                        <td>{log.description}</td>
                                                    </tr>
                                                ))
                                        }
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                        </Modal.Body>
                    </Modal>

                    <Modal show={showSendStatementModal} onHide={() => setShowSendStatementModal(false)} backdrop={"static"} dialogClassName={"modal65PercentWidth"}>
                        <Modal.Header closeButton>
                            <Modal.Title>Δήλωση Έκδοσης Στοιχείων Παρόχου</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {loadingSendStatementData ? (
                                <React.Fragment>
                                    <div style={{textAlign: "center"}}>
                                        Παρακαλώ περιμένετε... <Spinner className={"ml-2"} animation={"border"} variant={"dark"} size={"sm"} />
                                    </div>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    <div className={"mb-2"}>
                                        Παρακαλώ συμπληρώστε τα παρακάτω πεδία για να αποστείλετε την Δήλωση έκδοσης στοιχείων μέσω Παρόχου βάση ν. Α 1112/2025 Άρθρο 6.
                                    </div>
                                    <Row className={"mb-2 pt-2 border-top"}>
                                        <Col md={4}>
                                            <Input
                                                label={"ΑΦΜ Υπόχρεης Οντότητας"}
                                                value={ispInfo.entityVatNumber}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col md={4}>
                                            <Input
                                                label={"Κατηγορία Υπόχρεης Οντότητας"}
                                                value={formatMyDataProviderType(ispInfo.liableUserCategory)}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col md={4}>
                                            <Input
                                                label={"Τύπος Παρόχου"}
                                                value={formatMyDataProviderType(ispInfo.providerType)}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className={"mb-2"}>
                                        <Col md={4}>
                                            <Input
                                                label={"ΑΦΜ Παρόχου"}
                                                value={ispInfo.providerVatNumber}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col md={8}>
                                            <Input
                                                label={"Αριθμός Αδείας Παρόχου"}
                                                value={ispInfo.providerLicenceNumber}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className={"mb-2"}>
                                        <Col md={4}>
                                            <Input
                                                name={"providerContractNumber"}
                                                label={"Αριθμός Σύμβασης Παρόχου"}
                                                value={ispInfo.providerContractNumber}
                                                onChange={(e) => {
                                                    setISPInfo({...ispInfo, providerContractNumber: e.target.value})
                                                }}
                                            />
                                        </Col>
                                        <Col md={4}>
                                            <DateTimeBox
                                                name={"providerContractConclusionDate"}
                                                label={"Ημ/νια σύναψης σύμβασης οντότητας με πάροχο"}
                                                allowOtherYears={true}
                                                selected={moment(ispInfo.providerContractConclusionDate, "YYYY-MM-DDTHH:mm:ss[Z]").isValid()
                                                    ? moment(ispInfo.providerContractConclusionDate, "YYYY-MM-DDTHH:mm:ss[Z]").toDate() : null}
                                                onChange={(e) => {
                                                    if (moment(e).isValid()) {
                                                        setISPInfo({...ispInfo, providerContractConclusionDate: moment(e).format("YYYY-MM-DDTHH:mm:ss[Z]")})
                                                    } else {
                                                        setISPInfo({...ispInfo, providerContractConclusionDate: ""})
                                                    }
                                                }}
                                            />
                                        </Col>
                                        <Col md={4}>
                                            <DateTimeBox
                                                name={"providerContractActivationDate"}
                                                label={"Ημ/νια έναρξης ισχύος της σύμβασης"}
                                                allowOtherYears={true}
                                                selected={moment(ispInfo.providerContractActivationDate, "YYYY-MM-DDTHH:mm:ss[Z]").isValid()
                                                    ? moment(ispInfo.providerContractActivationDate, "YYYY-MM-DDTHH:mm:ss[Z]").toDate() : null}
                                                onChange={(e) => {
                                                    if (moment(e).isValid()) {
                                                        setISPInfo({...ispInfo, providerContractActivationDate: moment(e).format("YYYY-MM-DDTHH:mm:ss[Z]")})
                                                    } else {
                                                        setISPInfo({...ispInfo, providerContractActivationDate: ""})
                                                    }
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className={"mb-2"}>
                                        <Col md={6}>
                                            <DateBox
                                                name={"issueStartDate"}
                                                label={"Ημ/νια έναρξης έκδοσης στοιχείων για συναλλαγές"}
                                                allowOtherYears={true}
                                                selected={moment(ispInfo.issueStartDate, "YYYY-MM-DD").isValid() ? moment(ispInfo.issueStartDate, "YYYY-MM-DD").toDate() : null}
                                                onChange={(e) => {
                                                    if (moment(e).isValid()) {
                                                        setISPInfo({...ispInfo, issueStartDate: moment(e).format("YYYY-MM-DD")})
                                                    } else {
                                                        setISPInfo({...ispInfo, issueStartDate: ""})
                                                    }
                                                }}
                                            />
                                        </Col>
                                        <Col md={2}>
                                            <BetterCheckBox
                                                text={"Συναλλαγές B2C"}
                                                className={"mb-1 mt-4"}
                                                name={"isB2CTransactions"}
                                                checked={ispInfo.isB2CTransactions}
                                                onChange={(e) => {
                                                    setISPInfo({...ispInfo, isB2CTransactions: e.target.checked})
                                                }}
                                            />
                                        </Col>
                                        <Col md={2}>
                                            <BetterCheckBox
                                                text={"Συναλλαγές B2B"}
                                                className={"mb-1 mt-4"}
                                                name={"isB2BTransactions"}
                                                checked={ispInfo.isB2BTransactions}
                                                onChange={(e) => {
                                                    setISPInfo({...ispInfo, isB2BTransactions: e.target.checked})
                                                }}
                                            />
                                        </Col>
                                        <Col md={2}>
                                            <BetterCheckBox
                                                text={"Συναλλαγές B2G"}
                                                className={"mb-1 mt-4"}
                                                name={"isB2GTransactions"}
                                                checked={ispInfo.isB2GTransactions}
                                                onChange={(e) => {
                                                    setISPInfo({...ispInfo, isB2GTransactions: e.target.checked})
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className={"mb-2"}>
                                        <Col md={selectedISP === "custom" ? 3 : 6}>
                                            <OurDropdown
                                                name={"selectedISP"}
                                                label={"Όνομα Παρόχου ISP"}
                                                key={selectedISP}
                                                options={ispOptions}
                                                defaultValue={ispOptions.find((el) => el.value === selectedISP)}
                                                onChange={(e) => {
                                                    setSelectedISP(e.value);
                                                    setISPInfo({...ispInfo, internetProvider: e.value === "custom" ? "" : e.value});
                                                }}
                                            />
                                        </Col>
                                        {selectedISP === "custom" && (
                                            <Col md={3}>
                                                <Input
                                                    name={"internetProvider"}
                                                    label={"Χειροκίνητο Όνομα ISP"}
                                                    value={ispInfo.internetProvider}
                                                    charLimit={100}
                                                    required={true}
                                                    autoComplete={"off"}
                                                    onChange={(e) => {
                                                        setISPInfo({...ispInfo, internetProvider: e.target.value})
                                                    }}
                                                />
                                            </Col>
                                        )}
                                        <Col md={3}>
                                            <Input
                                                name={"internetProviderContractNumber"}
                                                label={"Κωδικός Σύμβασης ISP"}
                                                value={ispInfo.internetProviderContractNumber}
                                                charLimit={100}
                                                required={true}
                                                autoComplete={"off"}
                                                onChange={(e) => {
                                                    setISPInfo({...ispInfo, internetProviderContractNumber: e.target.value})
                                                }}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <DateBox
                                                name={"internetProviderContractDate"}
                                                label={"Ημερομηνία Σύμβασης ISP"}
                                                allowOtherYears={true}
                                                selected={moment(ispInfo.internetProviderContractDate, "YYYY-MM-DD").isValid() ? moment(ispInfo.internetProviderContractDate, "YYYY-MM-DD").toDate() : null}
                                                onChange={(e) => {
                                                    if (moment(e).isValid()) {
                                                        setISPInfo({...ispInfo, internetProviderContractDate: moment(e).format("YYYY-MM-DDTHH:mm:ss[Z]")})
                                                    } else {
                                                        setISPInfo({...ispInfo, internetProviderContractDate: ""})
                                                    }
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className={"mb-2"}>
                                        <Col md={4}>
                                            <div style={{marginTop: "28px"}}>
                                                <BetterCheckBox
                                                    name={"sendEmailOnSave"}
                                                    text={"Αποστολή ειδοποίησης e-mail κατά την αποστολή"}
                                                    checked={ispInfoEmail.sendEmail === true}
                                                    onChange={(e) => {
                                                        setISPInfoEmail({
                                                            ...ispInfoEmail,
                                                            sendEmail: e.target.checked,
                                                            email: validateEmail(String(selectedClientForModal.email).trim()) ? String(selectedClientForModal.email).trim() : ""
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                        {ispInfoEmail.sendEmail === true && (
                                            <Col md={4}>
                                                <Input
                                                    name={"sendEmailOnSaveEmail"}
                                                    label={"E-Mail"}
                                                    value={ispInfoEmail.email}
                                                    onChange={(e) => {
                                                        setISPInfoEmail({...ispInfoEmail, email: e.target.value});
                                                    }}
                                                />
                                            </Col>
                                        )}
                                    </Row>
                                </React.Fragment>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-primary" onClick={() => setShowSendStatementModal(false)}>
                                Κλείσιμο
                            </Button>
                            <Button variant="primary" disabled={loadingSendStatement} onClick={() => handleSendStatement()}>
                                Αποστολή {loadingSendStatement && <Spinner className={"ml-2"} animation="border" variant="dark" />}
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={showStatementModal} onHide={() => setShowStatementModal(false)} dialogClassName={"modal65PercentWidth"}>
                        <Modal.Header closeButton>
                            <Modal.Title>Προβολή Έκδοσης Στοιχείων Παρόχου</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {loadingShowStatementData ? (
                                <React.Fragment>
                                    <div style={{textAlign: "center"}}>
                                        Παρακαλώ περιμένετε... <Spinner className={"ml-2"} animation={"border"} variant={"dark"} size={"sm"} />
                                    </div>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    <Row className={"mb-2"}>
                                        <Col md={2}>
                                            <Input
                                                name={"statementId"}
                                                label={"Αρ. Υποβολής"}
                                                disabled={true}
                                                value={showStatementData.statementId}
                                            />
                                        </Col>
                                        <Col md={2}>
                                            <Input
                                                name={"status"}
                                                label={"Κατάσταση"}
                                                disabled={true}
                                                value={formatStatementStatus(showStatementData?.status)}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Input
                                                name={"created_at"}
                                                label={"Ημερομηνία υποβολής"}
                                                value={moment(showStatementData.created_at).isValid() ? moment(showStatementData.created_at).format("DD/MM/YYYY HH:mm") : ""}
                                                disabled={true}
                                            />
                                        </Col>
                                        {["accepted", "sent"].includes(showStatementData.status) ? (
                                            <Col md={5}>
                                                {!isPrimerConstructor && (
                                                    <React.Fragment>
                                                        {showStatementData.status === "sent" && (
                                                            <Button size={"sm"} disabled={loadingCheckAcceptance} style={{marginTop: "28px"}} onClick={() => handleCheckAcceptance(showStatementData)}>
                                                                Έλεγχος αποδοχής {loadingCheckAcceptance && <Spinner className={"ml-1"} animation="border" variant="dark" />}
                                                            </Button>
                                                        )}
                                                        <Button variant={"outline-danger"} size={"sm"} style={{marginTop: "28px"}} className={"ml-1"} onClick={() => {
                                                            setToRecallStatement(showStatementData.statementId);
                                                        }}>Ανάκληση δήλωσης</Button>
                                                    </React.Fragment>
                                                )}
                                            </Col>
                                        ) : (
                                            <React.Fragment>
                                                <Col md={5} className={"mt-2"} style={{textAlign: "center"}}>
                                                    Ανακλημένη δήλωση. Τύπος ανάκλησης: {showStatementData.recallStatus === "1" ? (
                                                        <span><strong>Μερική ανάκληση</strong> με ημερομηνία ισχύος <strong>{moment(showStatementData.recallDate, "YYYY-MM-DD").format("DD/MM/YYYY")}</strong></span>
                                                ) : (
                                                    <span><strong>Πλήρης ανάκληση</strong></span>
                                                )} και ημερομηνία υποβολής <strong>{moment(showStatementData.created_at).format("DD/MM/YYYY HH:mm")}</strong>
                                                </Col>
                                            </React.Fragment>
                                        )}
                                    </Row>
                                    {showStatementData?.acceptVatNumber && (
                                        <Row className={"mb-2"}>
                                            <Col md={3}>
                                                <Input
                                                    name={"acceptVatNumber"}
                                                    label={"ΑΦΜ αποδοχής δήλωσης"}
                                                    value={showStatementData.acceptVatNumber}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col md={4}>
                                                <Input
                                                    name={"internetProviderContractNumber"}
                                                    label={"Ημερομηνία αποδοχής δήλωσης"}
                                                    value={moment(showStatementData.acceptDate).format("DD/MM/YYYY HH:mm")}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>
                                    )}
                                    <Row className={"mb-2 pt-2 border-top"}>
                                        <Col md={4}>
                                            <Input
                                                label={"ΑΦΜ Υπόχρεης Οντότητας"}
                                                value={showStatementData.entityVatNumber}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col md={4}>
                                            <Input
                                                label={"Κατηγορία Υπόχρεης Οντότητας"}
                                                value={formatMyDataProviderType(showStatementData.liableUserCategory)}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col md={4}>
                                            <Input
                                                label={"Τύπος Παρόχου"}
                                                value={formatMyDataProviderType(showStatementData.providerType)}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className={"mb-2"}>
                                        <Col md={4}>
                                            <Input
                                                label={"ΑΦΜ Παρόχου"}
                                                value={showStatementData.providerVatNumber}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col md={8}>
                                            <Input
                                                label={"Αριθμός Αδείας Παρόχου"}
                                                value={showStatementData.providerLicenceNumber}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className={"mb-2"}>
                                        <Col md={4}>
                                            <Input
                                                name={"providerContractNumber"}
                                                label={"Αριθμός Σύμβασης Παρόχου"}
                                                value={showStatementData.providerContractNumber}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col md={4}>
                                            <DateTimeBox
                                                name={"providerContractConclusionDate"}
                                                label={"Ημ/νια σύναψης σύμβασης οντότητας με πάροχο"}
                                                allowOtherYears={true}
                                                selected={moment(showStatementData.providerContractConclusionDate, "YYYY-MM-DDTHH:mm:ss[Z]").isValid()
                                                    ? moment(showStatementData.providerContractConclusionDate, "YYYY-MM-DDTHH:mm:ss[Z]").toDate() : null}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col md={4}>
                                            <DateTimeBox
                                                name={"providerContractActivationDate"}
                                                label={"Ημ/νια έναρξης ισχύος της σύμβασης"}
                                                allowOtherYears={true}
                                                selected={moment(showStatementData.providerContractActivationDate, "YYYY-MM-DDTHH:mm:ss[Z]").isValid()
                                                    ? moment(showStatementData.providerContractActivationDate, "YYYY-MM-DDTHH:mm:ss[Z]").toDate() : null}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className={"mb-2"}>
                                        <Col md={6}>
                                            <DateBox
                                                name={"issueStartDate"}
                                                label={"Ημ/νια έναρξης έκδοσης στοιχείων για συναλλαγές"}
                                                allowOtherYears={true}
                                                selected={moment(showStatementData.issueStartDate, "YYYY-MM-DD").isValid() ? moment(showStatementData.issueStartDate, "YYYY-MM-DD").toDate() : null}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col md={2}>
                                            <BetterCheckBox
                                                text={"Συναλλαγές B2C"}
                                                className={"mb-1 mt-4"}
                                                name={"isB2CTransactions"}
                                                checked={showStatementData.isB2CTransactions}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col md={2}>
                                            <BetterCheckBox
                                                text={"Συναλλαγές B2B"}
                                                className={"mb-1 mt-4"}
                                                name={"isB2BTransactions"}
                                                checked={showStatementData.isB2BTransactions}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col md={2}>
                                            <BetterCheckBox
                                                text={"Συναλλαγές B2G"}
                                                className={"mb-1 mt-4"}
                                                name={"isB2GTransactions"}
                                                checked={showStatementData.isB2GTransactions}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className={"mb-2"}>
                                        <Col md={3}>
                                            <Input
                                                name={"internetProvider"}
                                                label={"Όνομα ISP"}
                                                value={showStatementData.internetProvider}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Input
                                                name={"internetProviderContractNumber"}
                                                label={"Κωδικός Σύμβασης ISP"}
                                                value={showStatementData.internetProviderContractNumber}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <DateBox
                                                name={"internetProviderContractDate"}
                                                label={"Ημερομηνία Σύμβασης ISP"}
                                                allowOtherYears={true}
                                                selected={moment(showStatementData.internetProviderContractDate, "YYYY-MM-DD").isValid() ? moment(showStatementData.internetProviderContractDate, "YYYY-MM-DD").toDate() : null}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                </React.Fragment>
                            )}
                        </Modal.Body>
                    </Modal>

                    <Modal show={!isEmpty(toRecallStatement)} onHide={() => setToRecallStatement("")} backdrop={"static"}>
                        <Modal.Header closeButton>
                            <Modal.Title>Ανάκληση δήλωσης</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className={"mb-2"}>
                                Είσαστε σίγουροι ότι θέλετε να πραγματοποιήσετε ανάκληση; Παρακαλώ τον τύπο της ανάκλησης
                            </div>
                            <div className={"pt-2 border-top"}>
                                <OurDropdown
                                    name={"recallStatus"}
                                    options={recallStatusOptions}
                                    label={"Τύπος Ανάκλησης"}
                                    key={recallStatus}
                                    defaultValue={recallStatusOptions.find((el) => el.value === recallStatus)}
                                    onChange={(e) => {
                                        setRecallStatus(e.value);
                                    }}
                                />
                                {recallStatus === '1' && (
                                    <DateBox
                                        label={"Ημερομηνία Ανάκλησης"}
                                        name={"recallDate"}
                                        selected={moment(recallDate, "YYYY-MM-DD").isValid() ? moment(recallDate, "YYYY-MM-DD").toDate() : null}
                                        onChange={(e) => {
                                            if (moment(e).isValid()) {
                                                setRecallDate(moment(e).format("YYYY-MM-DD"));
                                            } else {
                                                setRecallDate("");
                                            }
                                        }}
                                    />
                                )}
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-primary" onClick={() => setToRecallStatement("")}>
                                Όχι, κλείσιμο
                            </Button>
                            <Button variant="outline-danger" onClick={() => handleRecallStatement()} disabled={loadingRecall}>
                                Ναι, ανάκληση {loadingRecall && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={showSendStatementTableModal} onHide={() => setShowSendStatementTableModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Ιστορικό Δηλώσεων Έκδοσης Στοιχείων</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <table className={"simpleClassicTable"}>
                                <colgroup>
                                    <col span={1} style={{width: "20%"}}></col>
                                    <col span={1} style={{width: "30%"}}></col>
                                    <col span={1} style={{width: "30%"}}></col>
                                    <col span={1} style={{width: "20%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>Αρ. Υποβολής</th>
                                    <th>Ημ/νια Υποβολής</th>
                                    <th>Κατάσταση</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {sendStatementTableData.map((row, idx) => (
                                    <tr key={`rcpct-${idx}`}>
                                        <td>{row.statementId}</td>
                                        <td>{moment(row.created_at).format("DD/MM/YYYY HH:mm")}</td>
                                        <td>{formatStatementStatus(row.status)}</td>
                                        <td>
                                            <Button size="sm" variant="primary" title={"Προβολή Έκδοσης Στοιχείων"} style={{padding: "5px"}} onClick={() => handleShowSendStatementData(selectedClientForModal, row.statementId)}>
                                                <FaEye size={20} />
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </Modal.Body>
                    </Modal>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default ClientsProviderContractsReport;